export default __webpack_public_path__ + "a0d725b6d1f5da9b12df9f9e7fd060b4.png";